import { NgClass } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatGridList, MatGridTile } from "@angular/material/grid-list";
import { Data } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { AuthGamesService } from "@core/AuthServices/authGames/auth-games.service";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { AnimationItem } from "lottie-web";
import { AnimationOptions, LottieComponent } from "ngx-lottie";
import { Subscription } from "rxjs";
import { CommonVariable } from "src/app/app.constants";
import { GamesFeedSampleService } from "src/app/pages/games-feed-sample/games-feed-sample.service";
import { GamesRepositoryService } from "src/app/pages/games/games-repository.service";
import { GameDatasService } from "src/app/pages/games/services/game-data.service";

const fiveSec = 5000;
@Component({
  selector: "app-prize-box",
  templateUrl: "./prize-box.component.html",
  styleUrls: ["./prize-box.component.css"],
  standalone: true,
  imports: [
    LottieComponent,
    NgClass,
    MatGridList,
    MatGridTile,
    TranslatePipe,
  ],
})
export class PrizeBoxComponent {
  animationComplete: boolean;
  lottie_anim: string;
  prizeBox_anim: AnimationOptions;
  prizeList: Data;
  private anim: AnimationItem;
  claimedPrizeOrder: number;
  claimedPrizeData: Data;
  matrixAnimation: boolean;
  userTapped: boolean;
  selectedLanguage: string;
  translatedToastMsg: Data;
  toast: Data;
  private languageSubscription: Subscription;
  private constantsMsgSubscription: Subscription;
  private rapidFireDetailsSubscription: Subscription | undefined;
  private prizeBoxDetailsSubscription: Subscription | undefined;
  private previousStarToken: number | undefined;
  star_token: number | undefined;
  allPrizesData: Data;
  constructor(
    private matDialogRef: MatDialogRef<PrizeBoxComponent>,
    private gameRepoService: GamesRepositoryService,
    private gameDatasService: GameDatasService,
    private authService: AuthService,
    public translate: TranslateService,
    public gamesFeedService: GamesFeedSampleService,
    private AuthGamesService: AuthGamesService,
    @Inject(MAT_DIALOG_DATA) public data: Data
  ) {
    //This method is used to translate the text
    this.languageSubscription = this.authService.selectedlanguage$.subscribe(
      (l) => {
        this.selectedLanguage = l;
        translate.use(l ?? "en");
      },
      (err) => {
        return err;
      }
    );

    this.constantsMsgSubscription = this.authService?.getConstantsMsg$?.subscribe((msg: Data) => {
      this.translatedToastMsg = msg?.static_messages_pwa;
      if (this.translatedToastMsg) {
        this.toast = this.translatedToastMsg[1008];
      }
    }, (err) => {
      return err;
    });
    this.prizeList = data?.prizeBoxData?.prize_list || data?.prizeBoxData?.prizeList;
    this.claimedPrizeOrder = data?.claimPrizeData?.prize_order;
    this.lottie_anim = data?.prizeBoxData?.lottie_url || '../../../assets/lotti_animation/game_page/prize_box.json';
    // This is the prize box lottie animation
    if (this.lottie_anim) {
      this.prizeBox_anim = {
        path: this.lottie_anim,
        loop: false,
        autoplay: false,
      };
    }

    if (this.prizeList) {
      this.prizeList.forEach((element) => {
        if (element?.type == "credit" || element?.type == "cash") {
          this.gameDatasService.getDVCurrency(element.value)?.then((res: string) => {
            element["convertedValue"] = this.formatNoDecimals(res);
          });
        } else if (element?.type == "game") {
          element["convertedValue"] = "x" + element?.value;
        } else {
          element["convertedValue"] = this.formatNoDecimals(element?.value);
        }
        if (element?.prize_order === this.claimedPrizeOrder) {
          this.claimedPrizeData = element;
        }
      });
    }
    this.animationComplete = false
    this.matrixAnimation = false
    this.userTapped = false

    this.prizeBoxDetailsSubscription = this.AuthGamesService.getPrizeBoxGameData$.subscribe(
      (data: Data) => {
        this.allPrizesData = data;
      },
      (error) => {
        return error;
      })
    this.rapidFireDetailsSubscription = this.gamesFeedService?.getRapidFireDetails$?.subscribe(
      (ref: Data) => {
        this.star_token = ref[0]?.star_token
      },
      (error) => {
        return error;
      }
    );
  }

  ngOnInit() {
    // Delay the lottie animation as per the UI design
    setTimeout(() => {
      if (!this.userTapped && this.anim?.isLoaded === true) {
        this.anim?.play();
        this.matrixAnimation = true;
        this.Played()
      }
    }, fiveSec);
  }

  //This method is used to handle lottie animation
  animationCreated(animationItem: AnimationItem): void {
    this.anim = animationItem;
    this.anim?.setSpeed(0.7);
  }

  //This method is used to play lottie animation
  playAnim() {
    if (this.anim) {
      this.userTapped = true;
      this.anim.play();
      this.matrixAnimation = true;
      this.Played();
    }
  }

  //This method is used to play claim prize animation
  Played() {
    setTimeout(() => {
      this.animationComplete = true;
    }, fiveSec);
  }

  // This is used to close the prize box
  async close() {
    await this.toastMessage();
    this.matDialogRef.close();
    if (this.anim) {
      this.anim.destroy();
    }
    await this.getStarTokens()
  }

  //This method is used to show toast message
  async toastMessage() {
    try {
      const translatedMsg: object = await this.authService.getConstantsMsg(1008);
      const defaultMsg = {
        message: {
          line_1: "Something went wrong",
          line_2: "",
          duration: 2000,
        },
        style: {
          icon: "tick circle error.svg",
          type: CommonVariable.error,
        },
      };
      this.authService.showToastMessage(translatedMsg, defaultMsg);
    } catch (error) {
      return error;
    }
  }


  ngOnDestroy(): void {
    this.languageSubscription?.unsubscribe();
    this.constantsMsgSubscription.unsubscribe();
    this.rapidFireDetailsSubscription?.unsubscribe();
    this.prizeBoxDetailsSubscription.unsubscribe();
  }

  async getStarTokens() {
    if (this.star_token && this.allPrizesData) {
      await this.gameRepoService.prizeBoxValues(this.star_token, this.allPrizesData);
    }
  }

  private formatNoDecimals(input: string | number | null | undefined): string | number | null | undefined {
    if (typeof input !== 'string') return input;
    return input.replace(/(\d[\d,]*)[\.,]\d+/g, '$1');
  }
}
